module.exports = path => () => import('@/views/' + path);